import { DAYS_FULL, DAYS_SHORT, MONTHS, MONTHS_SHORT } from "../data/constants";
import { getDaysInMonth, getFirstDayOfMonth, formatDate, formatDateShort, isSameDay, isInRange } from "../utils/date";

export default function RangeCalendar({
  start,
  end,
  onRangeChange,
  hovered,
  setHovered,
  pickerMonth,
  pickerYear,
  setPickerMonth,
  setPickerYear,
  compact,
}) {
  const daysInMonth = getDaysInMonth(pickerYear, pickerMonth);
  const firstDay = getFirstDayOfMonth(pickerYear, pickerMonth);

  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const prevM = () => {
    if (pickerMonth === 0) { setPickerMonth(11); setPickerYear(pickerYear - 1); }
    else setPickerMonth(pickerMonth - 1);
  };
  const nextM = () => {
    if (pickerMonth === 11) { setPickerMonth(0); setPickerYear(pickerYear + 1); }
    else setPickerMonth(pickerMonth + 1);
  };

  const handleClick = (day) => {
    const clicked = new Date(pickerYear, pickerMonth, day);
    if (!start || (start && end)) onRangeChange(clicked, null);
    else {
      if (clicked < start) onRangeChange(clicked, start);
      else if (isSameDay(clicked, start)) onRangeChange(clicked, clicked);
      else onRangeChange(start, clicked);
    }
  };

  const previewEnd = start && !end && hovered ? hovered : null;
  const displayEnd = end || previewEnd;
  const realStart = start && displayEnd && displayEnd < start ? displayEnd : start;
  const realEnd = start && displayEnd && displayEnd < start ? start : displayEnd;

  const dayLabels = compact ? DAYS_SHORT : DAYS_FULL;

  const getCellClass = (day) => {
    const date = new Date(pickerYear, pickerMonth, day);
    const isS = realStart && isSameDay(date, realStart);
    const isE = realEnd && isSameDay(date, realEnd);
    const inR = isInRange(date, realStart, realEnd);
    const single = isS && isE;

    let c = "ec-range-cell";
    if (inR && !single) {
      if (isS) c += " ec-range-cell--start";
      else if (isE) c += " ec-range-cell--end";
      else c += " ec-range-cell--in-range";
    }
    return c;
  };

  const getDayBtnClass = (day) => {
    const date = new Date(pickerYear, pickerMonth, day);
    const isS = realStart && isSameDay(date, realStart);
    const isE = realEnd && isSameDay(date, realEnd);

    let c = "ec-range-day-btn";
    if (isS || isE) c += " ec-range-day-btn--selected";
    else if (isSameDay(date, new Date())) c += " ec-range-day-btn--today";
    return c;
  };

  return (
    <div className="ec-range-cal">
      <div className="ec-range-nav">
        <button onClick={prevM} className="ec-mini-nav-btn">‹</button>
        <span className="ec-range-month">
          {compact ? MONTHS_SHORT[pickerMonth] : MONTHS[pickerMonth]} {pickerYear}
        </span>
        <button onClick={nextM} className="ec-mini-nav-btn">›</button>
      </div>

      <div className="ec-range-day-headers">
        {dayLabels.map((d, i) => <div key={i} className="ec-range-day-label">{d}</div>)}
      </div>

      <div className="ec-range-grid">
        {cells.map((day, i) => {
          if (!day) return <div key={`e${i}`} className="ec-range-cell ec-range-cell--empty" />;
          return (
            <div key={day} className={getCellClass(day)}>
              <button
                onClick={() => handleClick(day)}
                onMouseEnter={() => { if (start && !end) setHovered(new Date(pickerYear, pickerMonth, day)); }}
                onMouseLeave={() => setHovered(null)}
                className={getDayBtnClass(day)}
              >
                {day}
              </button>
            </div>
          );
        })}
      </div>

      <div className="ec-range-display">
        <div className={`ec-range-badge ${start ? "ec-range-badge--active" : "ec-range-badge--inactive"}`}>
          {start ? (compact ? formatDateShort(start) : formatDate(start)) : "Inicio"}
        </div>
        <span className="ec-range-arrow">→</span>
        <div className={`ec-range-badge ${end ? "ec-range-badge--active" : "ec-range-badge--inactive"}`}>
          {end ? (compact ? formatDateShort(end) : formatDate(end)) : "Fin"}
        </div>
      </div>

      <p className="ec-range-hint">
        {!start ? "Selecciona la fecha de inicio" : !end ? "Ahora selecciona la fecha de fin" : "Clic en cualquier fecha para reiniciar"}
      </p>
    </div>
  );
}
